// @flow

import styled from 'styled-components';

export const ErrorLabel = styled.span`
  display: inline-block;
  color: #ec7063;
  font-size: 0.86rem;
  font-weight: 400;
`;
